import DOMPurify from 'dompurify';
import React from 'react';

import { fontStyles } from '~src/theme/fontStyles';

import { CategoryExtensionProps } from '../category/category-manager';
import { colors } from '../theme/colors';

const sanitizeOptions = {
  ALLOWED_TAGS: ['a', 'br'],
  ALLOWED_ATTR: ['target', 'href'],
};

interface CustomTextProps {
  text: string;
  variant: 'primary' | 'secondary';
}

const CustomText: React.FC<CustomTextProps> = ({ text, variant }) => {
  return (
    <div
      css={{
        padding: variant === 'secondary' ? '16px' : '0',
        borderRadius: '2px',
        backgroundColor: variant === 'secondary' ? colors.neutral95 : 'unset',
        color: variant === 'secondary' ? colors.black : colors.neutral35,
        overflow: 'hidden',
      }}
    >
      <span
        css={styles.font}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text, sanitizeOptions) }}
      />
    </div>
  );
};

export const CustomTextExtension: React.FC<CategoryExtensionProps> = ({ category, selected }) => {
  if (!selected) {
    return null;
  }

  return (
    <>
      {category.custom_text && (
        <CustomText key="custom-text" text={category.custom_text} variant="primary" />
      )}
      {category.custom_info_text && (
        <CustomText key="custom-warning" text={category.custom_info_text} variant="secondary" />
      )}
    </>
  );
};

const styles = {
  font: {
    ...fontStyles.px12_18,
    letterSpacing: '0.1',
  },
};
